var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('introduction-banner'),_c('div',{staticClass:"contents"},[_c('introduction-s-n-s'),_c('introduction-benefit'),_c('introdcution-method'),_c('introduction-note')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }